import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { getSiteSettingsUrl } from '../utilities/get-site-settings-url';
/**
 * Fetches site setting by it's scope
 * @param scope Scope of necessary site setting
 * @returns Promise with site setting
 * @internal
 */
export var fetchSiteSetting = function (scope) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getSiteSettingsUrl(scope);
                return [4 /*yield*/, fetchGet(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response ? response[scope] || null : null];
        }
    });
}); };
